'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import { alpha } from '@mui/system/colorManipulator';
import { useRtl } from '@mui/system/RtlProvider';
import paginationItemClasses, { getPaginationItemUtilityClass } from "./paginationItemClasses.js";
import ButtonBase from "../ButtonBase/index.js";
import capitalize from "../utils/capitalize.js";
import createSimplePaletteValueFilter from "../utils/createSimplePaletteValueFilter.js";
import FirstPageIcon from "../internal/svg-icons/FirstPage.js";
import LastPageIcon from "../internal/svg-icons/LastPage.js";
import NavigateBeforeIcon from "../internal/svg-icons/NavigateBefore.js";
import NavigateNextIcon from "../internal/svg-icons/NavigateNext.js";
import useSlot from "../utils/useSlot.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var overridesResolver = function(props, styles) {
    var ownerState = props.ownerState;
    return [
        styles.root,
        styles[ownerState.variant],
        styles["size".concat(capitalize(ownerState.size))],
        ownerState.variant === 'text' && styles["text".concat(capitalize(ownerState.color))],
        ownerState.variant === 'outlined' && styles["outlined".concat(capitalize(ownerState.color))],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, color = ownerState.color, disabled = ownerState.disabled, selected = ownerState.selected, size = ownerState.size, shape = ownerState.shape, type = ownerState.type, variant = ownerState.variant;
    var slots = {
        root: [
            'root',
            "size".concat(capitalize(size)),
            variant,
            shape,
            color !== 'standard' && "color".concat(capitalize(color)),
            color !== 'standard' && "".concat(variant).concat(capitalize(color)),
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return composeClasses(slots, getPaginationItemUtilityClass, classes);
};
var PaginationItemEllipsis = styled('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: overridesResolver
})(memoTheme(function(param) {
    var theme = param.theme;
    var _obj;
    return _object_spread_props(_object_spread({}, theme.typography.body2), (_obj = {
        borderRadius: 32 / 2,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto'
    }, _define_property(_obj, "&.".concat(paginationItemClasses.disabled), {
        opacity: (theme.vars || theme).palette.action.disabledOpacity
    }), _define_property(_obj, "variants", [
        {
            props: {
                size: 'small'
            },
            style: {
                minWidth: 26,
                borderRadius: 26 / 2,
                margin: '0 1px',
                padding: '0 4px'
            }
        },
        {
            props: {
                size: 'large'
            },
            style: {
                minWidth: 40,
                borderRadius: 40 / 2,
                padding: '0 10px',
                fontSize: theme.typography.pxToRem(15)
            }
        }
    ]), _obj));
}));
var PaginationItemPage = styled(ButtonBase, {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: overridesResolver
})(memoTheme(function(param) {
    var theme = param.theme;
    var _obj, _obj1;
    return _object_spread_props(_object_spread({}, theme.typography.body2), (_obj1 = {
        borderRadius: 32 / 2,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary
    }, _define_property(_obj1, "&.".concat(paginationItemClasses.focusVisible), {
        backgroundColor: (theme.vars || theme).palette.action.focus
    }), _define_property(_obj1, "&.".concat(paginationItemClasses.disabled), {
        opacity: (theme.vars || theme).palette.action.disabledOpacity
    }), _define_property(_obj1, "transition", theme.transitions.create([
        'color',
        'background-color'
    ], {
        duration: theme.transitions.duration.short
    })), _define_property(_obj1, '&:hover', {
        backgroundColor: (theme.vars || theme).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            backgroundColor: 'transparent'
        }
    }), _define_property(_obj1, "&.".concat(paginationItemClasses.selected), (_obj = {
        backgroundColor: (theme.vars || theme).palette.action.selected,
        '&:hover': {
            backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.action.selectedChannel, " / calc(").concat(theme.vars.palette.action.selectedOpacity, " + ").concat(theme.vars.palette.action.hoverOpacity, "))") : alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, _define_property(_obj, "&.".concat(paginationItemClasses.focusVisible), {
        backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.action.selectedChannel, " / calc(").concat(theme.vars.palette.action.selectedOpacity, " + ").concat(theme.vars.palette.action.focusOpacity, "))") : alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }), _define_property(_obj, "&.".concat(paginationItemClasses.disabled), {
        opacity: 1,
        color: (theme.vars || theme).palette.action.disabled,
        backgroundColor: (theme.vars || theme).palette.action.selected
    }), _obj)), _define_property(_obj1, "variants", [
        {
            props: {
                size: 'small'
            },
            style: {
                minWidth: 26,
                height: 26,
                borderRadius: 26 / 2,
                margin: '0 1px',
                padding: '0 4px'
            }
        },
        {
            props: {
                size: 'large'
            },
            style: {
                minWidth: 40,
                height: 40,
                borderRadius: 40 / 2,
                padding: '0 10px',
                fontSize: theme.typography.pxToRem(15)
            }
        },
        {
            props: {
                shape: 'rounded'
            },
            style: {
                borderRadius: (theme.vars || theme).shape.borderRadius
            }
        },
        {
            props: {
                variant: 'outlined'
            },
            style: _define_property({
                border: theme.vars ? "1px solid rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / 0.23)") : "1px solid ".concat(theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
            }, "&.".concat(paginationItemClasses.selected), _define_property({}, "&.".concat(paginationItemClasses.disabled), {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }))
        },
        {
            props: {
                variant: 'text'
            },
            style: _define_property({}, "&.".concat(paginationItemClasses.selected), _define_property({}, "&.".concat(paginationItemClasses.disabled), {
                color: (theme.vars || theme).palette.action.disabled
            }))
        }
    ].concat(_to_consumable_array(Object.entries(theme.palette).filter(createSimplePaletteValueFilter([
        'dark',
        'contrastText'
    ])).map(function(param) {
        var _param = _sliced_to_array(param, 1), color = _param[0];
        var _obj;
        return {
            props: {
                variant: 'text',
                color: color
            },
            style: _define_property({}, "&.".concat(paginationItemClasses.selected), (_obj = {
                color: (theme.vars || theme).palette[color].contrastText,
                backgroundColor: (theme.vars || theme).palette[color].main,
                '&:hover': {
                    backgroundColor: (theme.vars || theme).palette[color].dark,
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                }
            }, _define_property(_obj, "&.".concat(paginationItemClasses.focusVisible), {
                backgroundColor: (theme.vars || theme).palette[color].dark
            }), _define_property(_obj, "&.".concat(paginationItemClasses.disabled), {
                color: (theme.vars || theme).palette.action.disabled
            }), _obj))
        };
    })), _to_consumable_array(Object.entries(theme.palette).filter(createSimplePaletteValueFilter([
        'light'
    ])).map(function(param) {
        var _param = _sliced_to_array(param, 1), color = _param[0];
        return {
            props: {
                variant: 'outlined',
                color: color
            },
            style: _define_property({}, "&.".concat(paginationItemClasses.selected), _define_property({
                color: (theme.vars || theme).palette[color].main,
                border: "1px solid ".concat(theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / 0.5)") : alpha(theme.palette[color].main, 0.5)),
                backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / ").concat(theme.vars.palette.action.activatedOpacity, ")") : alpha(theme.palette[color].main, theme.palette.action.activatedOpacity),
                '&:hover': {
                    backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / calc(").concat(theme.vars.palette.action.activatedOpacity, " + ").concat(theme.vars.palette.action.focusOpacity, "))") : alpha(theme.palette[color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            }, "&.".concat(paginationItemClasses.focusVisible), {
                backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / calc(").concat(theme.vars.palette.action.activatedOpacity, " + ").concat(theme.vars.palette.action.focusOpacity, "))") : alpha(theme.palette[color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }))
        };
    })))), _obj1));
}));
var PaginationItemPageIcon = styled('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon',
    overridesResolver: function(props, styles) {
        return styles.icon;
    }
})(memoTheme(function(param) {
    var theme = param.theme;
    return {
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px',
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(22)
                }
            }
        ]
    };
}));
var PaginationItem = /*#__PURE__*/ React.forwardRef(function PaginationItem(inProps, ref) {
    var props = useDefaultProps({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    var className = props.className, _props_color = props.color, color = _props_color === void 0 ? 'standard' : _props_color, component = props.component, _props_components = props.components, components = _props_components === void 0 ? {} : _props_components, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, page = props.page, _props_selected = props.selected, selected = _props_selected === void 0 ? false : _props_selected, _props_shape = props.shape, shape = _props_shape === void 0 ? 'circular' : _props_shape, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, _props_type = props.type, type = _props_type === void 0 ? 'page' : _props_type, _props_variant = props.variant, variant = _props_variant === void 0 ? 'text' : _props_variant, other = _object_without_properties(props, [
        "className",
        "color",
        "component",
        "components",
        "disabled",
        "page",
        "selected",
        "shape",
        "size",
        "slots",
        "slotProps",
        "type",
        "variant"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    var isRtl = useRtl();
    var classes = useUtilityClasses(ownerState);
    var _slots_previous, _slots_next, _slots_first, _slots_last;
    var externalForwardedProps = {
        slots: {
            previous: (_slots_previous = slots.previous) !== null && _slots_previous !== void 0 ? _slots_previous : components.previous,
            next: (_slots_next = slots.next) !== null && _slots_next !== void 0 ? _slots_next : components.next,
            first: (_slots_first = slots.first) !== null && _slots_first !== void 0 ? _slots_first : components.first,
            last: (_slots_last = slots.last) !== null && _slots_last !== void 0 ? _slots_last : components.last
        },
        slotProps: slotProps
    };
    var _useSlot = _sliced_to_array(useSlot('previous', {
        elementType: NavigateBeforeIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), PreviousSlot = _useSlot[0], previousSlotProps = _useSlot[1];
    var _useSlot1 = _sliced_to_array(useSlot('next', {
        elementType: NavigateNextIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), NextSlot = _useSlot1[0], nextSlotProps = _useSlot1[1];
    var _useSlot2 = _sliced_to_array(useSlot('first', {
        elementType: FirstPageIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), FirstSlot = _useSlot2[0], firstSlotProps = _useSlot2[1];
    var _useSlot3 = _sliced_to_array(useSlot('last', {
        elementType: LastPageIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), LastSlot = _useSlot3[0], lastSlotProps = _useSlot3[1];
    var rtlAwareType = isRtl ? ({
        previous: 'next',
        next: 'previous',
        first: 'last',
        last: 'first'
    })[type] : type;
    var IconSlot = {
        previous: PreviousSlot,
        next: NextSlot,
        first: FirstSlot,
        last: LastSlot
    }[rtlAwareType];
    var iconSlotProps = {
        previous: previousSlotProps,
        next: nextSlotProps,
        first: firstSlotProps,
        last: lastSlotProps
    }[rtlAwareType];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ _jsx(PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: clsx(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ _jsxs(PaginationItemPage, _object_spread_props(_object_spread({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: clsx(classes.root, className)
    }, other), {
        children: [
            type === 'page' && page,
            IconSlot ? /*#__PURE__*/ _jsx(PaginationItemPageIcon, _object_spread_props(_object_spread({}, iconSlotProps), {
                className: classes.icon,
                as: IconSlot
            })) : null
        ]
    }));
});
process.env.NODE_ENV !== "production" ? PaginationItem.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: PropTypes.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */ color: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'primary',
            'secondary',
            'standard'
        ]),
        PropTypes.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: PropTypes.elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ components: PropTypes.shape({
        first: PropTypes.elementType,
        last: PropTypes.elementType,
        next: PropTypes.elementType,
        previous: PropTypes.elementType
    }),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: PropTypes.bool,
    /**
   * The current page number.
   */ page: PropTypes.node,
    /**
   * If `true` the pagination item is selected.
   * @default false
   */ selected: PropTypes.bool,
    /**
   * The shape of the pagination item.
   * @default 'circular'
   */ shape: PropTypes.oneOf([
        'circular',
        'rounded'
    ]),
    /**
   * The size of the component.
   * @default 'medium'
   */ size: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'small',
            'medium',
            'large'
        ]),
        PropTypes.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: PropTypes.shape({
        first: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        last: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        next: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        previous: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: PropTypes.shape({
        first: PropTypes.elementType,
        last: PropTypes.elementType,
        next: PropTypes.elementType,
        previous: PropTypes.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.bool
        ])),
        PropTypes.func,
        PropTypes.object
    ]),
    /**
   * The type of pagination item.
   * @default 'page'
   */ type: PropTypes.oneOf([
        'end-ellipsis',
        'first',
        'last',
        'next',
        'page',
        'previous',
        'start-ellipsis'
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'outlined',
            'text'
        ]),
        PropTypes.string
    ])
} : void 0;
export default PaginationItem;
